import { render } from "./EvacuationReport.vue?vue&type=template&id=18c45064&ts=true"
import script from "./EvacuationReport.vue?vue&type=script&lang=ts"
export * from "./EvacuationReport.vue?vue&type=script&lang=ts"

import "./EvacuationReport.vue?vue&type=style&index=0&id=18c45064&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__